import * as React from 'react';
import { SelectSingleHierarchy } from 'app/area/shared/translated-components';
import { LoadOptions } from 'app/types-shared';
import { CodePickerState, CodeSinglePickerProps } from './types';

export class CodeSinglePicker extends React.PureComponent<CodeSinglePickerProps, CodePickerState> {

  public readonly state: Readonly<CodePickerState> = { loadedOptions: {} };

  private onLoadOptions = (options: LoadOptions) => {

    const { id, onLoadOptions } = this.props;

    onLoadOptions(id, options);
    this.setState({ loadedOptions: options });
  };

  public render() {

    const { id, label, valueItem, options, fetchingOptions, translation, showBackgroundColour, className, enableMultilineValidation,
      onChange, required, searchRequired, validation, readOnly, extraFooterButton, showSpinnerLabel, size, minLength,
      displayCategories, onLoadCategoryOptions, categoryOptions } = this.props;

    return <div className={`col-lg-${size || 6} col-sm-12 ${className || ''}`}>
      <SelectSingleHierarchy
        componentId={id}
        className={undefined}
        label={label ? { text: label, required: !!required } : undefined}
        readOnly={readOnly}
        extraFooterButton={extraFooterButton}
        valueItem={valueItem}
        searchRequired={searchRequired}
        onChange={onChange}
        showBackgroundColour={showBackgroundColour}
        showSpinnerLabel={showSpinnerLabel}
        descriptionAllLevels={true}
        enableMultilineValidation={enableMultilineValidation}
        validation={validation}

        options={options}
        fetching={fetchingOptions}
        loadOptions={this.state.loadedOptions}
        onLoadOptions={this.onLoadOptions}

        displayCategories={displayCategories}
        categoryOptions={categoryOptions}
        onLoadCategoryOptions={onLoadCategoryOptions}

        minLength={minLength}
        placeholder={translation && translation.search} />
    </div>;
  }
}
